import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import QuoteModal from "./QuoteModal";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isQuoteOpen, setIsQuoteOpen] = useState(false);

  const menuVariants = {
    initial: { scaleY: 0 },
    animate: { 
        scaleY: 1, 
        transition: { duration: 0.5, ease: [0.12, 0, 0.39, 0] } 
    },
    exit: { 
        scaleY: 0,
        transition: { delay: 0.5, duration: 0.5, ease: [0.22, 1, 0.36, 1] } 
    }
  };

  const linkVariants = {
    initial: { y: 80, opacity: 0 },
    animate: (i) => ({
        y: 0, 
        opacity: 1,
        transition: { delay: 0.5 + (i * 0.1), duration: 0.8, ease: [0.76, 0, 0.24, 1] }
    }),
    exit: { 
        y: 80, 
        opacity: 0,
        transition: { duration: 0.3 }
    }
  };

  const openQuoteModal = () => {
      setIsOpen(false);
      setIsQuoteOpen(true);
  }

  return (
    <>
        <nav className="fixed top-0 left-0 w-full z-50 px-4 md:px-8 py-6 flex justify-between items-center">
        <Link 
            to="/" 
            className={`text-xl md:text-2xl font-display font-bold tracking-widest hover-trigger relative z-50 transition-colors duration-300 ${isOpen ? 'text-black' : 'text-white mix-blend-difference'}`}
        >
            XLUMA
        </Link>

        <div className="flex items-center gap-4 md:gap-8 relative z-50">
            <button 
                onClick={() => setIsQuoteOpen(true)}
                className={`hidden md:block text-xs font-bold uppercase tracking-widest hover-trigger transition-colors duration-300 hover:text-accent ${isOpen ? 'text-black' : 'text-white mix-blend-difference'}`}
            >
                Get a Quote
            </button>

            <button 
                onClick={() => setIsOpen(!isOpen)} 
                className={`text-xs md:text-sm font-bold uppercase tracking-widest hover-trigger flex items-center gap-2 transition-colors duration-300 ${isOpen ? 'text-black' : 'text-white mix-blend-difference'}`}
            >
                <span className={`w-2 h-2 rounded-full animate-pulse ${isOpen ? 'bg-black' : 'bg-accent'}`}></span>
                {isOpen ? "Close" : "Menu"}
            </button>
        </div>

        <AnimatePresence>
            {isOpen && (
                <motion.div 
                    variants={menuVariants}
                    initial="initial"
                    animate="animate"
                    exit="exit"
                    className="fixed inset-0 bg-accent text-black origin-top flex flex-col justify-center items-center z-40"
                >
                    <div className="flex flex-col gap-2 md:gap-4 text-center">
                        {["Work", "Expertise", "Blog", "Contact"].map((item, i) => (
                            <div key={i} className="overflow-hidden">
                                <motion.a 
                                    href={item === "Blog" ? "/blog" : `#${item.toLowerCase()}`}
                                    custom={i}
                                    variants={linkVariants}
                                    className="text-5xl md:text-9xl font-display font-bold uppercase tracking-tighter hover:text-white transition-colors duration-300 block"
                                    onClick={() => setIsOpen(false)}
                                >
                                    {item}
                                </motion.a>
                            </div>
                        ))}
                        {/* Mobile "Get a Quote" link */}
                        <div className="overflow-hidden md:hidden mt-8">
                             <motion.button 
                                onClick={openQuoteModal}
                                custom={4}
                                variants={linkVariants}
                                className="text-2xl font-display font-bold uppercase tracking-widest hover:text-white transition-colors duration-300 border-2 border-black px-6 py-3"
                            >
                                Get a Quote
                            </motion.button>
                        </div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
        </nav>

        <QuoteModal isOpen={isQuoteOpen} onClose={() => setIsQuoteOpen(false)} />
    </>
  );
};

export default Navbar;
